var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.333v5c0 .92-.746 1.667-1.667 1.667h-9.166c-.92 0-1.667-.746-1.667-1.667v-9.166c0-.92.746-1.667 1.667-1.667h5M21 11h5v5M16.833 20.167L26 11"
  }))));
};
export default SvgExternalLink;